module.exports = __webpack_public_path__ + "static/media/sr.024ce0be.svg";